import { createIcon } from '@chakra-ui/icons'

export const MapIcon = createIcon({
  displayName: 'MapIcon',
  viewBox: '0 0 12 12',
  path: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 3.05549C2.5 1.95328 3.44124 1 4.5 1C5.55876 1 6.5 1.95328 6.5 3.05549C6.5 3.81994 5.89595 4.91985 4.69537 6.405C4.59298 6.53167 4.40702 6.53167 4.30463 6.405C3.10405 4.91985 2.5 3.81994 2.5 3.05549ZM4.50006 2.5C4.77592 2.5 5 2.7236 5 2.99994C5 3.27629 4.77591 3.5 4.50006 3.5C4.22412 3.5 4 3.27632 4 2.99994C4 2.72357 4.22411 2.5 4.50006 2.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.32444 5.87836L2 5.62502V9.55702L4 8.80702V7.5H5V8.80702L7 9.55702V4.88601C7 4.05232 7.51715 3.30607 8.29776 3.01335L10.3244 2.25336C10.6513 2.13078 11 2.37242 11 2.72152V9.15352C11 9.36194 10.8707 9.5485 10.6756 9.62169L7.68738 10.7423C7.62879 10.7661 7.56531 10.779 7.5 10.779C7.4347 10.779 7.37121 10.7661 7.31262 10.7423L4.5 9.68752L1.67556 10.7467C1.34869 10.8693 1 10.6276 1 10.2785V6.34652C1 6.1381 1.12929 5.95154 1.32444 5.87836ZM10 8.80702L8 9.55702V4.19302L10 3.44302V8.80702Z"
      />
    </>
  ),
})
